import { VehicleConstant } from "./VehicleConstant";

const VehicleAction = {};

VehicleAction.getVehicleData = (
  page
 
) => {
  return {
    type: VehicleConstant.VEHICLE_SAGA,
    payload: {
      page
     
    },
  };
};

VehicleAction.postVehicleData = (payload) => {
  return {
    type: VehicleConstant.ADD_VEHICLE_SAGA,
    payload: payload,
  };
};
VehicleAction.getVehicleDropdownData = () => {
 
  return {
    type: VehicleConstant.VEHICLE_DROPDOWN_SAGA,
  };
};
VehicleAction.postVehicleBulkData = (payload) => {
  return {
    type: VehicleConstant.POST_VEHICLE_BULK_API,
    payload: payload,
  };
};
VehicleAction.getVehicleTypeData = () => {
 
  return {
    type: VehicleConstant.VEHICLE_TYPES_SAGA,
  };
};
VehicleAction.getVehicleSubTypeData = (id) => {
  console.log('fheufheu',id);
  
 
  return {
    type: VehicleConstant.VEHICLE_SUB_TYPES_SAGA,
    payload: id,
  };
};
VehicleAction.getVehicleMenufaturerData = (id) => {
 
  return {
    type: VehicleConstant.VEHICLE_GET_MENUFATURER_SAGA,
    payload: id,
  };
};

VehicleAction.getVehicleModelData = (id) => {
 
  return {
    type: VehicleConstant.VEHICLE_MODEL_SAGA,
    payload: id,
  };
};
VehicleAction.getVehicleVariantData = (manufacturer_id,model_id) => {
  
  return {
    type: VehicleConstant.VEHICLE_VARIANT_DROPDOWN_SAGA,
    payload: {manufacturer_id,model_id},
  };
};

export { VehicleAction };
